import React from "react";
import { Route } from "react-router-dom";
import LeftSidebar from "../../component/admin/LeftSidebar";
import TopHeader from "../../component/admin/TopHeader";
const error = () => {
  return (
    <div className="fixed-left">
      <div id="wrapper">
        <Route component={LeftSidebar} />
        <div className="content-page">
          <div className="content">
            <Route component={TopHeader} />
            <div className="page-content-wrapper">
              <div className="col-lg-12 text-center">
                <div className="card mt-5 m-b-20">
                  <div className="card-body">
                    <h2> Something went wrong! Please try again... </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default error;



// WEBPACK FOOTER //
// ./src/component/admin/error.js